module.exports = __webpack_public_path__ + "img/szwyIcon2.7cee2db7.jpg";